import React from "react"

const DragAnchor = ({ ...rest }) => {
  return (
    <a className="palette-drag-handle palette-cell-icon" {...rest}>
      <i className="bi bi-list"></i>
    </a>
  );
};

export default DragAnchor;
